// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  font-family: "poppins", sans-serif;
}

/* Login & Register Page CSS start */
.loginpage {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #1b2430;
}

.registerpage {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #1b2430;
}

.logoutpage {
  min-height: 100vh;
  width: 100%;
  background-color: #1b2430;
}

.form-box-register {
  position: relative;
  width: 450px;
  height: 550px;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
}

.form-box-login {
  position: relative;
  width: 450px;
  height: 350px;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
}

.textr,
.textl {
  text-align: center;
  color: #bababa;
  margin: 0;
}

.inputbox {
  position: relative;
  margin: 25px 0;
  width: 300px;
  border-bottom: 2px solid #fff;
}

.inputbox label {
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1em;
  pointer-events: none;
  transition: 0.5s;
}

input:focus ~ label,
input:valid ~ label {
  top: -5px;
}
.inputbox input {
  width: 100%;
  height: 50px;
  background: transparent;
  border: none;
  outline: none;
  font-size: 1em;
  padding: 0 35px 0 5px;
  color: #fff;
}

.click input {
  width: 100%;
  height: 40px;
  border-radius: 40px;
  background: #17cf97;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  color: #f5f2f2;
}

.material-symbols-outlined {
  position: absolute;
  right: 8px;
  color: #17cf97;
  font-size: 1.7em;
}

.already {
  margin: 5px;
  display: flex;
  justify-content: right;
  color: #a3fbee;
  text-decoration: underline;
}
/* Login & Register Page CSS end */

/* NavBar CSS start */
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #1b2430;
  padding: 9px 10px;
}

#navbar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
}

#navbar li {
  list-style: none;
  padding: 0px 20px;
  position: relative;
}

#navbar li a {
  text-decoration: none;
  font-size: 1.15rem;
  font-weight: 600;
  color: #fff;
  transition: 0.3s ease-in-out;
}

#navbar li a:hover {
  color: #17cf97;
}

#navbar li a:hover::after {
  content: "";
  width: 30%;
  height: 2px;
  background-color: #17cf97;
  position: absolute;
  bottom: -4px;
  left: 20px;
}
/* NavBar CSS end */

/* Problems table CSS start */
.problemtable {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  width: 100%;
  background-color: #1b2430;
}
.content-table {
  border-collapse: collapse;
  margin: 10px auto;
  font-size: 0.9em;
  min-width: 1000px;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
  justify-content: center;
  align-items: center;
}

.content-table thead tr {
  background-color: #17cf97;
  color: #1b2430;
  text-align: left;
}

.content-table th,
.content-table td {
  padding: 10px 15px;
}

.content-table tbody tr:nth-of-type(even) {
  background-color: #e3e1e1;
}

.content-table tbody tr:nth-of-type(odd) {
  background-color: #ffffff;
}

.content-table tbody tr:last-of-type {
  border-bottom: 3.5px solid #17cf97;
}

.content-table a {
  text-decoration: underline;
  color: #3481e7;
  font-weight: bold;
}

.content-table a:hover {
  color: #17cf97;
}

.Easy {
  color: #3bc240;
  font-weight: bold;
}

.Medium {
  color: #f1a824;
  font-weight: bold;
}

.Hard {
  color: #d23636;
  font-weight: bold;
}
/* Problems table CSS end */

/* Problem Page CSS start */
.Easyhehe {
  max-height: 12000px;
  overflow-y: auto;
  color: #3bc240;
  font-size: 1.5em;
  font-weight: bold;
}

.Mediumhehe {
  max-height: 12000px;
  overflow-y: auto;
  color: #f1a824;
  font-size: 1.5em;
  font-weight: bold;
}

.Hardhehe {
  max-height: 12000px;
  overflow-y: auto;
  color: #d23636;
  font-size: 1.5em;
  font-weight: bold;
}

pre {
  white-space: pre-wrap;
  color: #e3e1e1;
  font-size: 0.9em;
  font-family: "Source Code Pro", Menlo, monospace;
}

.problempage {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #1b2430;
  min-height: 100vh;
  width: 100%;
}

.ques {
  margin: 0;
  padding: 0px 5px 0 15px;
}

.des {
  color: #17cf97;
  font-size: 1.2em;
  font-weight: bold;
  padding: 15px 0 0 0;
}

.cons,
.stc {
  color: #17cf97;
  font-size: 1.2em;
  font-weight: bold;
  padding: 10px 0 0 0;
}

.yout,
.eout {
  color: #17cf97;
  font-size: 0.9em;
  font-weight: bold;
}

.flexforstc {
  display: flex;
}

.ini,
.outi {
  color: #18beca;
  margin: 0;
}
.out {
  padding: 0 0 0 100px;
}

.page-content {
  min-height: 100vh;
  width: 100%;
  display: flex;
}

textarea {
  height: 69vh;
  width: 49vw;
  background-color: #1b2430;
  border-radius: 10px;
  border: 2px solid #9d9b9b;
  color: #e3e1e1;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
  font-family: "Courier New", Courier, monospace;
}

#test,
#submit {
  padding: 5px 10px 5px 10px;
  margin-right: 20px;
  font-weight: bold;
  border-radius: 20px 20px 20px 20px;
  cursor: pointer;
}

#test {
  background-color: #9d9b9b;
}
#submit {
  background-color: #17cf97;
}

.slang {
  color: #17cf97;
  display: flex;
  align-items: center;
  margin: 0 0 5px 0;
}

.label {
  margin-right: 10px;
  font-weight: bold;
}

.select {
  border-radius: 10px;
  border: 2px solid #9d9b9b;
  background-color: #1b2430;
  color: #fff;
}

.verdiv {
  padding: 10px 0 0 0;
}

.vertext {
  color: #17cf97;
  font-size: 1.1em;
  font-weight: bold;
}

.wa {
  color: #ff0f1e;
  font-size: 1.1em;
  font-weight: bold;
}
.ac {
  color: #07ac07;
  font-size: 1.1em;
  font-weight: bold;
}

.submilink {
  color: #a3fbee;
  text-decoration: underline;
  font-weight: bold;
  float: right;
  padding-right: 4px;
}
/*Problem Page CSS end */

/* Home Page CSS start */
.linkedinlink {
  color: #a3fbee;
  text-decoration: underline;
}

.homepage {
  background-color: #1b2430;
  min-height: 100vh;
  width: 100%;
}

.text1 {
  color: #c5c5c5;
  text-align: center;
  margin: 0;
  padding: 0 0 15px 0;
  font-weight: bold;
}

.text2 {
  color: #c5c5c5;
  text-align: center;
  margin: 0;
  padding: 20px 10px 0 10px;
  font-weight: bold;
}

.text3 {
  color: #c5c5c5;
  text-align: center;
  margin: 0;
  padding: 10px 10px 20px 10px;
}

.text4 {
  color: #c5c5c5;
  text-align: center;
  margin: 0;
  padding: 0;
}

@keyframes colorChange {
  0% {
    color: #04ff0d;
  }
  25% {
    color: #00eeff;
  }
  50% {
    color: #ffc965;
  }
  75% {
    color: #ff6df5;
  }
  100% {
    color: #9bff82;
  }
}

.tuoj {
  animation: colorChange 3s infinite;
  font-weight: bold;
}

.dogmeme {
  display: block;
  margin: 0 auto;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
  border-radius: 20px 20px 20px 20px;
}

.redirectbut {
  display: block;
  margin: 0 auto;
  padding: 5px 10px 5px 10px;
  font-weight: 1000;
  border-radius: 20px 20px 20px 20px;
  cursor: pointer;
  background-color: #17cf97;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
}
/* Home Page CSS end */

/* View Code CSS start */
.code-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(
    2px
  ); /* for safari browser (i mean who use it nowadays but google says so) */
  display: flex;
  justify-content: center;
  align-items: center;
}

.code-popup {
  background-color: #1b2430;
  padding: 2px 20px 20px 20px;
  border-radius: 25px;
  max-height: 85vh;
  max-width: 70vw;
  overflow-y: auto;
  overflow-x: auto;
  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);
}

.code-popup pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.code-popup button {
  margin-top: 10px;
}
/* View Code CSS end */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,UAAU;EACV,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;AACA,kCAAkC;;AAElC,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA,mBAAmB;;AAEnB,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA,2BAA2B;;AAE3B,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA,wBAAwB;;AAExB,wBAAwB;AACxB;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,gDAAgD;AAClD;AACA,sBAAsB;;AAEtB,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B;;GAEC,EAAE,uEAAuE;EAC1E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA,sBAAsB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap\");\n* {\n  margin: 0;\n  padding: 0;\n  font-family: \"poppins\", sans-serif;\n}\n\n/* Login & Register Page CSS start */\n.loginpage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  width: 100%;\n  background-color: #1b2430;\n}\n\n.registerpage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  width: 100%;\n  background-color: #1b2430;\n}\n\n.logoutpage {\n  min-height: 100vh;\n  width: 100%;\n  background-color: #1b2430;\n}\n\n.form-box-register {\n  position: relative;\n  width: 450px;\n  height: 550px;\n  background: transparent;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n}\n\n.form-box-login {\n  position: relative;\n  width: 450px;\n  height: 350px;\n  background: transparent;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n}\n\n.textr,\n.textl {\n  text-align: center;\n  color: #bababa;\n  margin: 0;\n}\n\n.inputbox {\n  position: relative;\n  margin: 25px 0;\n  width: 300px;\n  border-bottom: 2px solid #fff;\n}\n\n.inputbox label {\n  position: absolute;\n  top: 50%;\n  left: 5px;\n  transform: translateY(-50%);\n  color: #fff;\n  font-size: 1em;\n  pointer-events: none;\n  transition: 0.5s;\n}\n\ninput:focus ~ label,\ninput:valid ~ label {\n  top: -5px;\n}\n.inputbox input {\n  width: 100%;\n  height: 50px;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 1em;\n  padding: 0 35px 0 5px;\n  color: #fff;\n}\n\n.click input {\n  width: 100%;\n  height: 40px;\n  border-radius: 40px;\n  background: #17cf97;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 1em;\n  font-weight: 600;\n  color: #f5f2f2;\n}\n\n.material-symbols-outlined {\n  position: absolute;\n  right: 8px;\n  color: #17cf97;\n  font-size: 1.7em;\n}\n\n.already {\n  margin: 5px;\n  display: flex;\n  justify-content: right;\n  color: #a3fbee;\n  text-decoration: underline;\n}\n/* Login & Register Page CSS end */\n\n/* NavBar CSS start */\nnav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #1b2430;\n  padding: 9px 10px;\n}\n\n#navbar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0px;\n}\n\n#navbar li {\n  list-style: none;\n  padding: 0px 20px;\n  position: relative;\n}\n\n#navbar li a {\n  text-decoration: none;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #fff;\n  transition: 0.3s ease-in-out;\n}\n\n#navbar li a:hover {\n  color: #17cf97;\n}\n\n#navbar li a:hover::after {\n  content: \"\";\n  width: 30%;\n  height: 2px;\n  background-color: #17cf97;\n  position: absolute;\n  bottom: -4px;\n  left: 20px;\n}\n/* NavBar CSS end */\n\n/* Problems table CSS start */\n.problemtable {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 100vh;\n  width: 100%;\n  background-color: #1b2430;\n}\n.content-table {\n  border-collapse: collapse;\n  margin: 10px auto;\n  font-size: 0.9em;\n  min-width: 1000px;\n  border-radius: 20px 20px 0 0;\n  overflow: hidden;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n  justify-content: center;\n  align-items: center;\n}\n\n.content-table thead tr {\n  background-color: #17cf97;\n  color: #1b2430;\n  text-align: left;\n}\n\n.content-table th,\n.content-table td {\n  padding: 10px 15px;\n}\n\n.content-table tbody tr:nth-of-type(even) {\n  background-color: #e3e1e1;\n}\n\n.content-table tbody tr:nth-of-type(odd) {\n  background-color: #ffffff;\n}\n\n.content-table tbody tr:last-of-type {\n  border-bottom: 3.5px solid #17cf97;\n}\n\n.content-table a {\n  text-decoration: underline;\n  color: #3481e7;\n  font-weight: bold;\n}\n\n.content-table a:hover {\n  color: #17cf97;\n}\n\n.Easy {\n  color: #3bc240;\n  font-weight: bold;\n}\n\n.Medium {\n  color: #f1a824;\n  font-weight: bold;\n}\n\n.Hard {\n  color: #d23636;\n  font-weight: bold;\n}\n/* Problems table CSS end */\n\n/* Problem Page CSS start */\n.Easyhehe {\n  max-height: 12000px;\n  overflow-y: auto;\n  color: #3bc240;\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n.Mediumhehe {\n  max-height: 12000px;\n  overflow-y: auto;\n  color: #f1a824;\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n.Hardhehe {\n  max-height: 12000px;\n  overflow-y: auto;\n  color: #d23636;\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\npre {\n  white-space: pre-wrap;\n  color: #e3e1e1;\n  font-size: 0.9em;\n  font-family: \"Source Code Pro\", Menlo, monospace;\n}\n\n.problempage {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  background-color: #1b2430;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.ques {\n  margin: 0;\n  padding: 0px 5px 0 15px;\n}\n\n.des {\n  color: #17cf97;\n  font-size: 1.2em;\n  font-weight: bold;\n  padding: 15px 0 0 0;\n}\n\n.cons,\n.stc {\n  color: #17cf97;\n  font-size: 1.2em;\n  font-weight: bold;\n  padding: 10px 0 0 0;\n}\n\n.yout,\n.eout {\n  color: #17cf97;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.flexforstc {\n  display: flex;\n}\n\n.ini,\n.outi {\n  color: #18beca;\n  margin: 0;\n}\n.out {\n  padding: 0 0 0 100px;\n}\n\n.page-content {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n}\n\ntextarea {\n  height: 69vh;\n  width: 49vw;\n  background-color: #1b2430;\n  border-radius: 10px;\n  border: 2px solid #9d9b9b;\n  color: #e3e1e1;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n  font-family: \"Courier New\", Courier, monospace;\n}\n\n#test,\n#submit {\n  padding: 5px 10px 5px 10px;\n  margin-right: 20px;\n  font-weight: bold;\n  border-radius: 20px 20px 20px 20px;\n  cursor: pointer;\n}\n\n#test {\n  background-color: #9d9b9b;\n}\n#submit {\n  background-color: #17cf97;\n}\n\n.slang {\n  color: #17cf97;\n  display: flex;\n  align-items: center;\n  margin: 0 0 5px 0;\n}\n\n.label {\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.select {\n  border-radius: 10px;\n  border: 2px solid #9d9b9b;\n  background-color: #1b2430;\n  color: #fff;\n}\n\n.verdiv {\n  padding: 10px 0 0 0;\n}\n\n.vertext {\n  color: #17cf97;\n  font-size: 1.1em;\n  font-weight: bold;\n}\n\n.wa {\n  color: #ff0f1e;\n  font-size: 1.1em;\n  font-weight: bold;\n}\n.ac {\n  color: #07ac07;\n  font-size: 1.1em;\n  font-weight: bold;\n}\n\n.submilink {\n  color: #a3fbee;\n  text-decoration: underline;\n  font-weight: bold;\n  float: right;\n  padding-right: 4px;\n}\n/*Problem Page CSS end */\n\n/* Home Page CSS start */\n.linkedinlink {\n  color: #a3fbee;\n  text-decoration: underline;\n}\n\n.homepage {\n  background-color: #1b2430;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.text1 {\n  color: #c5c5c5;\n  text-align: center;\n  margin: 0;\n  padding: 0 0 15px 0;\n  font-weight: bold;\n}\n\n.text2 {\n  color: #c5c5c5;\n  text-align: center;\n  margin: 0;\n  padding: 20px 10px 0 10px;\n  font-weight: bold;\n}\n\n.text3 {\n  color: #c5c5c5;\n  text-align: center;\n  margin: 0;\n  padding: 10px 10px 20px 10px;\n}\n\n.text4 {\n  color: #c5c5c5;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n}\n\n@keyframes colorChange {\n  0% {\n    color: #04ff0d;\n  }\n  25% {\n    color: #00eeff;\n  }\n  50% {\n    color: #ffc965;\n  }\n  75% {\n    color: #ff6df5;\n  }\n  100% {\n    color: #9bff82;\n  }\n}\n\n.tuoj {\n  animation: colorChange 3s infinite;\n  font-weight: bold;\n}\n\n.dogmeme {\n  display: block;\n  margin: 0 auto;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n  border-radius: 20px 20px 20px 20px;\n}\n\n.redirectbut {\n  display: block;\n  margin: 0 auto;\n  padding: 5px 10px 5px 10px;\n  font-weight: 1000;\n  border-radius: 20px 20px 20px 20px;\n  cursor: pointer;\n  background-color: #17cf97;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n}\n/* Home Page CSS end */\n\n/* View Code CSS start */\n.code-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(\n    2px\n  ); /* for safari browser (i mean who use it nowadays but google says so) */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.code-popup {\n  background-color: #1b2430;\n  padding: 2px 20px 20px 20px;\n  border-radius: 25px;\n  max-height: 85vh;\n  max-width: 70vw;\n  overflow-y: auto;\n  overflow-x: auto;\n  box-shadow: 0 5px 200px rgba(5, 255, 197, 0.555);\n}\n\n.code-popup pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.code-popup button {\n  margin-top: 10px;\n}\n/* View Code CSS end */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
